import { render, staticRenderFns } from "./content1.vue?vue&type=template&id=2a355002&scoped=true"
import script from "./content1.vue?vue&type=script&lang=js"
export * from "./content1.vue?vue&type=script&lang=js"
import style0 from "./content1.vue?vue&type=style&index=0&id=2a355002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a355002",
  null
  
)

export default component.exports